module.exports = __webpack_public_path__ + "img/frame (39).560c2b0d.jpg";